exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".postage input[data-v-2508c465]{font-size:12px;padding:0 8px!important;height:20px;margin-right:6px;width:90px}.postage button[data-v-2508c465]{background-color:#052360;border-color:#052360;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2508c465","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/PostageRefillSettings.vue
// module id = gAOC
// module chunks = 1